import { useQuery } from "@tanstack/react-query"

import { getHistorial } from "../services/historial.service";

export const usePacienteHistorial = (id) => {

    const pacienteHistorialQuery = useQuery({
        queryKey: ['paciente/historial', id],
        queryFn: () => getHistorial(id),
        staleTime: 0, // nulo
    });

    return {
        pacienteHistorialQuery,
    }
}